import { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';

type TrustedDealerModalProviderProps = {
  children: ReactNode;
};

type TrustedDealerModalContextValue = {
  isTrustedDealerModalOpen: boolean;
  setIsTrustedDealerModalOpen: (open: boolean) => void;
};

const TrustedDealerModalContext = createContext<TrustedDealerModalContextValue>(
  {
    isTrustedDealerModalOpen: false,
    setIsTrustedDealerModalOpen: () => null,
  },
);

const TrustedDealerModalProvider = ({
  children,
}: TrustedDealerModalProviderProps) => {
  const [isTrustedDealerModalOpen, setIsTrustedDealerModalOpen] =
    useState<boolean>(false);

  const value = useMemo(
    () => ({
      isTrustedDealerModalOpen,
      setIsTrustedDealerModalOpen,
    }),
    [isTrustedDealerModalOpen],
  );

  return (
    <TrustedDealerModalContext.Provider value={value}>
      {children}
    </TrustedDealerModalContext.Provider>
  );
};

const useTrustedDealerModal = () => useContext(TrustedDealerModalContext);

export { TrustedDealerModalProvider, useTrustedDealerModal };
